import "./style.css";

import homeImg from "assets/img/home-icon.png";
import homeHoverImg from "assets/img/home-icon-hoover.png";

import { useHistory } from "react-router-dom";
import * as routes from "routes";
import { useContext, useState, useMemo, useRef, useEffect } from "react";

import { PageTransitionContext, getNextTransition } from "pageTransitionProvider";

// import Button from '@material-ui/core/Button';
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";

import { CSSTransition } from "react-transition-group";

import { CustomDialog } from "./infoDialog";

export const Info = (props) => {
  const { content } = props;
  const history = useHistory();
  const goToChoiceRef = useRef();

  const pageTransitionContext = useContext(PageTransitionContext);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState({});

  const [showActions, setShowActions] = useState(false);

  const [infoRead, setInfoRead] = useState(false);

  useEffect(() => {
    const tt = setTimeout(() => {
      setShowActions(true);
    }, 2000);
    return () => {
      clearTimeout(tt);
    };
  }, []);

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  /* Styles */
  const sequenceContainer = {
    // backgroundImage: `url(${content.background})`,
    ...(content.containerStyle || {}),
  };
  const fixedImageBackgroundStyle = {
    backgroundImage: `url(${content.fixedImageBackground || ""})`,
    ...(content.fixedImageBackgroundStyle || {}),
  };
  const contentStyle = {
    ...(content.contentStyle || {}),
  };

  const goNextStep = useMemo(() => {
    return () => {
      const nextStepIndex = props.allSteps.findIndex((step) => step.id === props.content.nextStepId);

      let nextPageLocation, nextPageTransition;

      if (nextStepIndex < 0) {
        nextPageLocation = routes.HOMEPAGE;
        nextPageTransition = getNextTransition();
      } else {
        nextPageLocation = `${routes.JOURNEY}/${props.name}/${nextStepIndex + 1}`;
        nextPageTransition = getNextTransition(props.allSteps[nextStepIndex].type, "info");
      }

      pageTransitionContext.handleSetAnimation(nextPageTransition).then((value) => {
        history.push(nextPageLocation);
      });

      // if (nextStepIndex < 0) history.push(routes.HOMEPAGE);
      // else history.push(`${routes.JOURNEY}/${props.name}/${nextStepIndex + 1}`);
    };
  }, [history, props.allSteps, props.content.nextStepId, props.name, pageTransitionContext]);

  const goBackHome = () => {
    const nextPageTransition = getNextTransition();

    pageTransitionContext.handleSetAnimation(nextPageTransition).then(() => {
      history.push(routes.HOMEPAGE);
    });
  };

  // const sequence = useMemo(() => {
  //   return (props.content.sequence && props.content.sequence[props.lang]) || [];
  // }, [props.content.sequence, props.lang]);

  return (
    <div id="info" className="background-cover flex flex-column " style={sequenceContainer}>
      {content.fixedImageBackground && <div className="fixed-background background-cover" style={fixedImageBackgroundStyle}></div>}
      {props.lang && (
        <>
          <div className="control-container flex">
            <button className="go-back-home-button" onClick={goBackHome}>
              <span className="info">{"<"}&nbsp;Home </span> <img src={content.homeIcon || homeImg} alt="" />{" "}
              <img className="on-hover" src={content.homeHoverIcon || homeHoverImg} alt="" />
            </button>
          </div>

          <div className="content flex flex-column " style={contentStyle}>
            <div className="content-text" dangerouslySetInnerHTML={{ __html: content.contentText }}></div>

            <CSSTransition in={showActions} timeout={1000} classNames="actionsAnimation" unmountOnExit>
              <>
                <div className="actions-container">
                  {content.actionText && <div className="action-text" dangerouslySetInnerHTML={{ __html: content.actionText }}></div>}
                  <div className="actions flex flex-wrap justify-content-center align-items-start">
                    {content.actions &&
                      content.actions.map((act, ind) => {
                        if (act.type === "button") {
                          let clickAction = () => {
                            setInfoRead(true);
                            console.warn("undefined action");
                          };
                          if (act.action === "openDialog") {
                            clickAction = () => {
                              setInfoRead(true);
                              setDialogContent(act.dialogContent || {});
                              handleDialogOpen();

                              setTimeout(() => {
                                goToChoiceRef.current.scrollIntoView({ behavior: "smooth" });
                              }, 500);
                            };
                          }
                          return (
                            <CustomButton key={act.key || ind} onClick={clickAction} customstyle={act.buttonStyle || {}} className="action-button">
                              <div className="icon">
                                {act.icon && <img src={act.icon} alt="" />}
                                {act.iconHover && <img className="on-hover" src={act.iconHover} alt="" />}
                              </div>
                              <div>{act.text}</div>
                            </CustomButton>
                          );
                        }
                        return <></>;
                      })}
                  </div>
                </div>
                <div ref={goToChoiceRef} className="action-next">
                  <CustomButton onClick={goNextStep} disabled={!infoRead} className="go-next-button" customstyle={content.nextButtonStyle || {}}>
                    <div>{content.nextButtonText}</div>
                  </CustomButton>
                </div>
              </>
            </CSSTransition>
          </div>
        </>
      )}

      <CustomDialog lang={props.lang} open={dialogOpen} dialogContent={dialogContent} close={handleDialogClose}></CustomDialog>
    </div>
  );
};

const CustomButton = (props) => {
  const customStyle = makeStyles((theme) => ({
    customButton: props.customstyle || {},
  }))();

  return (
    <button onClick={props.onClick} disabled={props.disabled || false} className={clsx(props.className, customStyle.customButton)}>
      {props.children}
    </button>
  );
};
